import { useRef } from 'react';
import { useInViewport } from 'react-in-viewport';
import ToCart from './block/ToCart';
import Flags from './block/Flags';
import Fav from './block/Fav';
import Img from './block/Img';
import SkuTooltip from './block/SkuTooltip';
import PricePerUnit from '../common/cmpt/priceCtrl/PricePerUnit';
import ValuePerUnit from './block/ValuePerUnit';
import Units from '../common/cmpt/priceCtrl/Units';
import AmountInput from '../common/cmpt/priceCtrl/AmountInput';

const GridItem = ({ prod, data }) => {
  const itemRef = useRef();

  const { inViewport } = useInViewport(
    itemRef,
    { threshold: 0.1 },
    { disconnectOnLeave: false },
  );

  const { id, name, link, brand, brandImg, sku } = prod;
  const { renderPrice, showModal, inStock, inCart, withPriceAndAvail } = data;

  const orderformBtnTitle = withPriceAndAvail
    ? 'Купить в 1 клик'
    : 'Узнать цену';

  const tooltipId = `desktop-sku-${id}`;
  const tooltipMobId = `mob-sku-${id}`;

  return (
    <div className="category__box grid-item" ref={itemRef}>
      {!inViewport && <div className="category__cart" />}

      {inViewport && (
        <div className="category__cart">
          <div className="duct__flex">
            <div className="product__lur">
              <Flags data={data} prod={prod} />
            </div>
            <Fav data={data} />
          </div>

          <Img prod={prod} />

          <div className="category__logo">
            <SkuTooltip sku={sku} tooltipId={tooltipId} />
            <img src={brandImg} alt={brand} />
          </div>
          <div className="sku-mob">
            <SkuTooltip sku={sku} tooltipId={tooltipMobId} />
          </div>

          <div className="availability">
            {inStock && (
              <div className="in-stock">
                <img src="/static/img/icons/tick.svg" alt="in-stock" />
                <span>В наличии</span>
              </div>
            )}
            {!inStock && (
              <div className="on-order__it">
                <img src="/static/img/icons/tick1.svg" alt="by-order" />
                <span>Под заказ</span>
              </div>
            )}
          </div>

          <div className="product__info">
            <div className="prod-col__mob">
              <PricePerUnit
                prod={prod}
                valueCmpt={ValuePerUnit}
                renderPrice={renderPrice}
              />
              <Units prod={prod} show={renderPrice} />
              <a
                href={link}
                className="product__tit"
                dangerouslySetInnerHTML={{ __html: name }}
              />
            </div>

            <div className="add-to-cart">
              <div className="add-catalog-for-shop">
                {inCart && <AmountInput prod={prod} />}
              </div>
              {!inCart && <ToCart data={data} showIcon />}
            </div>
          </div>

          <div className="category-prod-none">
            <span className="btn-click" onClick={showModal}>
              {orderformBtnTitle}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default GridItem;
